import React from 'react';
import styled from "styled-components";
import { Box, Tab, Tabs, Typography } from '@mui/material';

const BoxWrap = styled.div`
    width: 100%;
    margin: auto;
    
`;
const NavWrap = styled.div`
    background-color: yellow;

`;
const NavWrap2 = styled.div`
    height: 200px;
    background-color: green;
`;


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const PCNav = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div>
            <BoxWrap>
                <NavWrap>
                    <ol>
                        <li>사랑니</li>
                        <li>임플란트</li>
                    </ol>
                </NavWrap>
                <NavWrap2>
                    <ol>
                        <li>사랑니</li>
                        <li>임플란트</li>
                    </ol>
                </NavWrap2>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent:"center" }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="임플란트" {...a11yProps(0)} />
                        <Tab label="사랑니 발치" {...a11yProps(1)} />
                        <Tab label="심미 치료" {...a11yProps(2)} />
                        <Tab label="커뮤니티" {...a11yProps(3)} />
                        </Tabs>
                    </Box>
                    <div style={{width: "1000px", margin: "auto"}}>
                        <TabPanel value={value} index={0}>
                            임플란트
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            사랑니 발치
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            심미 치료
                        </TabPanel>
                        <TabPanel value={value} index={3}>
                            커뮤니티
                        </TabPanel>
                    </div>
                </Box>
            </BoxWrap>
            
        </div>
    );
};

export default PCNav;